module.exports = __webpack_public_path__ + "img/huiyuan.3aa28b56.png";